var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-0",attrs:{"fluid":""}},[_c('user-stats'),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',[_vm._v(_vm._s(_vm.$t( 'dashboardView.listOfYourNotConfirmedVacationsTitle' ))+" ")])])],1),_c('vacation-request-list',{attrs:{"vacations":_vm.notConfirmedVacations,"visibilityConfig":{
                            search: false,
                            refresh: true,
                            excludeHeaders: [
                                'user.firstName',
                                'user.lastName',
                                'isConfirmed',
                                'action'
                            ]
                        }},on:{"refresh":_vm.onRefreshVacations}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }